<template>
  <rect opacity="0.5" x="4" y="3" width="8" height="5" rx="0.5" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3 1.5H13C13.2761 1.5 13.5 1.72386 13.5 2V14C13.5 14.2761 13.2761 14.5 13 14.5H3C2.72386 14.5 2.5 14.2761 2.5 14V2C2.5 1.72386 2.72386 1.5 3 1.5ZM1 2C1 0.895431 1.89543 0 3 0H13C14.1046 0 15 0.895431 15 2V14C15 15.1046 14.1046 16 13 16H3C1.89543 16 1 15.1046 1 14V2ZM4.5 11C4.22386 11 4 11.2239 4 11.5V12.5C4 12.7761 4.22386 13 4.5 13H11.5C11.7761 13 12 12.7761 12 12.5V11.5C12 11.2239 11.7761 11 11.5 11H4.5Z"
  />
</template>
